"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RxDbKeyValueStorage = void 0;
var tslib_1 = require("tslib");
var isArray_1 = tslib_1.__importDefault(require("lodash/isArray"));
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var KeyValue_1 = require("./collections/KeyValue");
var connection_1 = require("./connection");
var RxDbKeyValueStorage = /** @class */ (function () {
    function RxDbKeyValueStorage(__STORE_NAME__, encrypted, dbName) {
        if (encrypted === void 0) { encrypted = false; }
        if (dbName === void 0) { dbName = "app"; }
        this.__STORE_NAME__ = __STORE_NAME__;
        this.encrypted = encrypted;
        this.dbName = dbName;
    }
    RxDbKeyValueStorage.prototype.getCollection = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var db;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, connection_1.RxDbConnection.get(this.dbName)];
                    case 1:
                        db = _a.sent();
                        if (this.encrypted) {
                            return [2 /*return*/, db.collections[KeyValue_1.EncryptedKeyValue.name]];
                        }
                        return [2 /*return*/, db.collections[KeyValue_1.KeyValue.name]];
                }
            });
        });
    };
    RxDbKeyValueStorage.prototype.getAllAsync = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var collection, docs;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCollection()];
                    case 1:
                        collection = _a.sent();
                        return [4 /*yield*/, collection
                                .find()
                                .where("group")
                                .equals(this.__STORE_NAME__)
                                .exec()];
                    case 2:
                        docs = _a.sent();
                        return [2 /*return*/, docs];
                }
            });
        });
    };
    RxDbKeyValueStorage.prototype.keys = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var docs;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAllAsync()];
                    case 1:
                        docs = _a.sent();
                        return [2 /*return*/, docs.map(function (doc) { return doc.key; })];
                }
            });
        });
    };
    RxDbKeyValueStorage.prototype.getAsync = function (key, defaultValue) {
        if (defaultValue === void 0) { defaultValue = null; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var id, collection, res, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (/\//.test(key)) {
                            throw new Error("key不能包含'/'");
                        }
                        id = this.__STORE_NAME__ + "/" + key;
                        return [4 /*yield*/, this.getCollection()];
                    case 1:
                        collection = _a.sent();
                        return [4 /*yield*/, collection.findByIds([id])];
                    case 2:
                        res = _a.sent();
                        result = defaultValue;
                        if (res.has(id)) {
                            result = res.get(id).toJSON().value._;
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    RxDbKeyValueStorage.prototype.setAsync = function (key, value) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var id, collection, res;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (/\//.test(key)) {
                            throw new Error("key不能包含'/'");
                        }
                        id = this.__STORE_NAME__ + "/" + key;
                        return [4 /*yield*/, this.getCollection()];
                    case 1:
                        collection = _a.sent();
                        return [4 /*yield*/, collection.atomicUpsert({
                                id: id,
                                key: key,
                                group: this.__STORE_NAME__,
                                value: {
                                    _: value,
                                },
                            })];
                    case 2:
                        res = _a.sent();
                        return [2 /*return*/, res.value.data];
                }
            });
        });
    };
    RxDbKeyValueStorage.prototype.batchSetObject = function (obj, keyProp, valueProp) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, obj_1, obj_1_1, item, key, val, id, key, id, val, collection;
            var e_1, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        data = [];
                        if (isArray_1.default(obj)) {
                            if (!keyProp) {
                                throw new Error("批量写入数据未数组时,必须提供keyProp");
                            }
                            try {
                                for (obj_1 = tslib_1.__values(obj), obj_1_1 = obj_1.next(); !obj_1_1.done; obj_1_1 = obj_1.next()) {
                                    item = obj_1_1.value;
                                    key = item[keyProp];
                                    if (!key || key == "") {
                                        continue;
                                    }
                                    val = item;
                                    if (valueProp) {
                                        val = item[valueProp];
                                    }
                                    id = this.__STORE_NAME__ + "/" + key;
                                    data.push({ id: id, key: key, group: this.__STORE_NAME__, value: { _: val } });
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (obj_1_1 && !obj_1_1.done && (_a = obj_1.return)) _a.call(obj_1);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                        }
                        else {
                            for (key in obj) {
                                id = this.__STORE_NAME__ + "/" + key;
                                val = obj[key];
                                data.push({ id: id, key: key, group: this.__STORE_NAME__, value: { _: val } });
                            }
                        }
                        return [4 /*yield*/, this.getCollection()];
                    case 1:
                        collection = _b.sent();
                        return [2 /*return*/, collection.bulkInsert(data)];
                }
            });
        });
    };
    RxDbKeyValueStorage.prototype.removeAsync = function (key) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.batchRemoveAsync([key])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RxDbKeyValueStorage.prototype.batchRemoveAsync = function (keys) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var collection, query;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCollection()];
                    case 1:
                        collection = _a.sent();
                        query = collection
                            .find()
                            .where("id")
                            .in(keys.map(function (k) {
                            return _this.__STORE_NAME__ + "/" + k;
                        }));
                        return [4 /*yield*/, query.remove()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RxDbKeyValueStorage.prototype.clearAsync = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var collection, query;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCollection()];
                    case 1:
                        collection = _a.sent();
                        query = collection
                            .find()
                            .where("group")
                            .equals(this.__STORE_NAME__);
                        return [4 /*yield*/, query.remove()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RxDbKeyValueStorage.prototype.setObjectPropertyAsync = function (key, propertyName, value) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var obj;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAsync(key)];
                    case 1:
                        obj = _a.sent();
                        if (!obj) {
                            obj = {};
                        }
                        obj[propertyName] = value;
                        return [2 /*return*/, this.setAsync(key, obj)];
                }
            });
        });
    };
    RxDbKeyValueStorage.prototype.getObjectPropertiesAsync = function (key) {
        var propertyNames = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            propertyNames[_i - 1] = arguments[_i];
        }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var obj, result, propertyNames_1, propertyNames_1_1, propertyName;
            var e_2, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getAsync(key)];
                    case 1:
                        obj = _b.sent();
                        if (!obj) {
                            obj = {};
                        }
                        result = {};
                        try {
                            for (propertyNames_1 = tslib_1.__values(propertyNames), propertyNames_1_1 = propertyNames_1.next(); !propertyNames_1_1.done; propertyNames_1_1 = propertyNames_1.next()) {
                                propertyName = propertyNames_1_1.value;
                                result[propertyName] = obj[propertyName];
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (propertyNames_1_1 && !propertyNames_1_1.done && (_a = propertyNames_1.return)) _a.call(propertyNames_1);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    RxDbKeyValueStorage.prototype.getObjectValueAsync = function (key, propertyName) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var obj;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAsync(key)];
                    case 1:
                        obj = _a.sent();
                        if (obj) {
                            return [2 /*return*/, obj[propertyName]];
                        }
                        return [2 /*return*/, null];
                }
            });
        });
    };
    RxDbKeyValueStorage.diOptions = di_1.default.options({
        name: "kvStorage",
        scope: "Request",
    });
    return RxDbKeyValueStorage;
}());
exports.RxDbKeyValueStorage = RxDbKeyValueStorage;
